import { Clonable } from '../../..';
import { SubscriptionStatus, SubscriptionInterval } from '../../data/entities/subscription.entity';

export class Subscription extends Clonable {
  constructor(
    public readonly status: SubscriptionStatus,
    public readonly seats: number,
    public readonly endDate: Date,
    public readonly productId: string,
    public readonly priceId: string,
    public readonly customerId: string,
    public readonly subscriptionId: string,
    public readonly price: number,
    public readonly currency: string,
    public readonly interval: SubscriptionInterval,
    public readonly lastSyncedAt: Date,
  ) {
    super();
  }

  public willAutoRenew(): boolean {
    return this.status === SubscriptionStatus.Active;
  }

  public isActive(): boolean {
    return this.willAutoRenew() && this.isValid();
  }

  public isValid(): boolean {
    return Date.now() <= this.endDate.getTime();
  }

  public isStripe(): boolean {
    return ![SubscriptionStatus.Legacy, SubscriptionStatus.Trial].includes(this.status);
  }
}
